// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5b378342","260":"a73a223b","453":"67362217","579":"81633b31","607":"75f41a9a","902":"e1fd2446"}[chunkId] + ".chunk.js";
};